import {axiosUtil} from "../../../utils/axios_util";

const userAccountApi = {

    //分页获取用户账户列表
    getPowerPage(data:powerSearchData) {
        return axiosUtil({
            url: '/user_account/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //删除用户账户
    deleteUserAccount(data: string) {
        return axiosUtil({
            url: `/user_account/delete/${data}`,
            method: 'get',
            data
        })
    },
    //编辑用户账户
    editUserAccount(data:any) {
        return axiosUtil({
            url: `/user_account/edit/${data.accountNo}`,
            method: 'post',
            data,
        })
    },

    //获取当前登录账户管理的用户组列表
    getManageAccountList() {
        return axiosUtil({
            url: `/user_account/get_management_group_list`,
            method: 'get'
        })
    },
    //获取当前登录账户可查看的的用户组列表
    getManageAccountReadList() {
        return axiosUtil({
            url: `/user_account/get_readable_group_list`,
            method: 'get'
        })
    },
    //邀请新用户
    inviteUserAccount(data:any) {
        return axiosUtil({
            url: `/user_account/invite`,
            method: 'post',
            data,
        })
    },
    //设置账户用户组关联关系
    setRelationAccountGroup(data:any) {
        return axiosUtil({
            url: `/user_account/set_account_group_relation/${data.accountNo}`,
            method: 'post',
            data,
        })
    },
    //获取账户用户组关联关系
    getRelationAccountGroup(data:any) {
        return axiosUtil({
            url: `/user_account/get_account_group_relation/${data}`,
            method: 'get',
            data,
        })
    },

    //是否启用用户账户
    setEnable(data:any) {
        return axiosUtil({
            url: `/user_account/enable/${data.accountNo}`,
            method: 'get',
            data,
            params: {
                enable: data.isEnable
            }
        })
    },
}

export default userAccountApi
